export default {
  trackingEvent: function (event, params = {}) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      return window.dataLayer.push(Object.assign({}, { event }, params));
    }
  },

  getTrackingParams: function (selector) {
    const params = selector.getAttribute('data-tracking-params') || '{}';
    return JSON.parse(params);
  }
};
